import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-762a02d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "today-is-holiday"
}
const _hoisted_2 = {
  key: 1,
  class: "today-is-saturday"
}

import { onMounted, ref, watch, onUnmounted } from 'vue';
import { isSameDay } from "date-fns";

import { useHolidayStore } from '@/store/common/holidayStore';

import HolidayService from "@/service/master/HolidayService";
import { IHolidayComponent } from "@/interface/component/master/i-holiday-component";


export default /*#__PURE__*/_defineComponent({
  __name: 'X1CalendarDrop',
  setup(__props) {

const holidayStore = useHolidayStore();
const holidayService = ref(new HolidayService());

const x1Calendar = ref();
const right = ref(0);
const x1CalendarDiv = ref();

onMounted(() => {
    getHolidays();
    handleResize();
    window.addEventListener('resize', handleResize);
    x1CalendarDiv.value.removeAttribute('id');
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

watch(() => x1Calendar.value, () => {
    handleResize();
}, { deep: true });

const handleResize = ()=>{
    right.value = 40;
}

const onKeydown = (event: any) => {
    if (event.code === 'Enter') {
        x1Calendar.value.overlayVisible = false;
    }
}

const cleanCalendarValue = () => {
    x1Calendar.value.updateModel(null);
}

const onIconClick = () => {
    x1Calendar.value.$el.children[0].focus();
}

const isHoliday = (date: any) => {

    let dateStr = date.year + '/' + (date.month + 1) + '/' + date.day;
    let holidayDate = new Date(dateStr);

    let index = holidayStore.holidays.findIndex((item) => {

        let d = new Date(item.holiday);

        return isSameDay(holidayDate, d);
    });

    return index >= 0;
}

const isSaturday = (date: any) => {
    let dateStr = date.year + '/' + (date.month + 1) + '/' + date.day;
    let holidayDate = new Date(dateStr);
    let nowDay = holidayDate.getDay();
    let weeks = ["日", "月", "火", "水", "木", "金", "土"];
    return weeks[nowDay];
}

const getHolidays = () => {
    if (holidayStore.holidays.length === 0) {
        holidayService.value.list()
            .then(data => {
                holidayStore.holidays = data as IHolidayComponent[];
            });
    }
}

return (_ctx: any,_cache: any) => {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "position-relative flex align-items-center",
    ref_key: "x1CalendarDiv",
    ref: x1CalendarDiv
  }, [
    _createVNode(_component_Calendar, _mergeProps(_ctx.$attrs, {
      ref_key: "x1Calendar",
      ref: x1Calendar,
      dateFormat: _ctx.$attrs.dateFormat ? _ctx.$attrs.dateFormat : 'yy/mm/dd',
      onKeypress: _withKeys(onKeydown, ["enter"]),
      style: {"width":"100%"},
      inputStyle: _ctx.$attrs.inputStyle ? _ctx.$attrs.inputStyle : 'border: 0px;border-radius: 0px;border-bottom: 1px solid #C0BFBF;font-weight: bold;font-family: Inter;font-size: 36px;text-align: left;color: black;height: 56px;background: transparent;'
    }), {
      date: _withCtx((slotProps) => [
        (isHoliday(slotProps.date) || isSaturday(slotProps.date) === '日')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("strong", null, _toDisplayString(slotProps.date.day), 1)
            ]))
          : _createCommentVNode("", true),
        (isSaturday(slotProps.date) === '土' && !isHoliday(slotProps.date))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(slotProps.date.day), 1)
            ]))
          : _createCommentVNode("", true),
        (!isHoliday(slotProps.date) && !isSaturday(slotProps.date))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(slotProps.date.day), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["dateFormat", "onKeypress", "inputStyle"]),
    _withDirectives(_createElementVNode("span", {
      class: "pi pi-times position-absolute",
      style: _normalizeStyle('right:'+right.value+'px;'),
      onClick: cleanCalendarValue
    }, null, 4), [
      [_vShow, _ctx.$attrs.modelValue && !_ctx.$attrs.disabled && _ctx.$attrs.showX1Clear]
    ]),
    _createElementVNode("i", {
      class: "position-absolute pi pi-angle-down",
      style: {"right":"0","cursor":"pointer","font-size":"22px"},
      onClick: onIconClick
    })
  ], 512))
}
}

})